import { Injectable } from '@angular/core';
import { NavigationStart, Router, RoutesRecognized } from '@angular/router';
import { pairwise, filter, map } from 'rxjs/operators';
import { SESSION_KEYS } from 'src/app/dataModels/session-keys';
import { SessionService } from '../session/session.service';
/**
 * Route service, subscribes to router events and provides the previous component url
 */
@Injectable({
  providedIn: 'root',
})
export class RouteService {
  /**
   * previous route url
   */
  private __previousUrl: string;

  /**
   * constructor to inject dependency
   * Filter the router events for NavigationStart, RoutesRecognized
   * Once NavigationStart is filtered, subscribe to the state by mapping router's getCurrentNavigation
   * Clear the session state if the navigation has occurred from SideBar
   * Once RoutesRecognized is filtered, use pairwise to get from and to routes, the first element of the pairwise will be the from url
   * @param router instance of router
   * @param sessionService instance of SessionService
   */
  constructor(private router: Router, private sessionService: SessionService) {
    this.router.events
      .pipe(
        filter((e) => e instanceof NavigationStart),
        map(() => this.router.getCurrentNavigation().extras.state)
      )
      .subscribe((x) => {
        if (x) {
          this.sessionService.removeSessionData(SESSION_KEYS.ROW_DATA);
        }
      });

    this.router.events
      .pipe(
        filter((e: any) => e instanceof RoutesRecognized),
        pairwise()
      )
      .subscribe((e: any) => {
        this.__previousUrl = e[0].urlAfterRedirects; // previous url
      });
  }

  /**
   * getter for previous url
   */
  public get previousUrl(): string {
    return this.__previousUrl;
  }
}
